export const apiTypes = {
  DEFAULT: 0,
  REPORT_API: 1,
  ALT_NAV_API: 2,
};
